import { ReportDialog, ViewMode } from '@pages/osi/reports/_tabs/_accountReports/types';
import {
  AccountReport,
  AccountReportList,
  AccountReportListItem,
  OperationTypes
} from '@shared/types/osi/accountReports';
import { AccountType } from '@shared/types/dictionaries';

interface PreviewDialog {
  isOpen: boolean;

  previewHtml: string;

  closePreviewDialog(): void;

  openPreviewDialog(): void;
}

export interface AccountReportsService {
  // Properties
  hookForm: any;
  reportDialog: ReportDialog;
  reportForPublish: any;
  dialog: DialogState;
  isAcceptDialogOpen: boolean;
  previewDialog: PreviewDialog;

  // Getters
  readonly isLoading: boolean;
  // Идёт ли загрузка каталога категорий (для отображения состояния в ячейке «Категория»)
  readonly isCategoriesLoading: boolean;
  readonly isGridLoading: boolean;
  readonly isGridError: boolean;
  readonly allReports: AccountReport[];
  readonly editingListPeriod: string;

  // Methods
  getAllowedCategories(operationType: OperationTypes, accountType: AccountType): any[] | undefined;

  cancelPublishReport(): void;

  initialize(): Promise<void>;

  loadReports(): Promise<void>;

  onPublishClick(report: AccountReport): Promise<void>;

  previewReport(report: AccountReport): Promise<void>;

  publishReportInFreeMode(data: any): Promise<void>;

  onEditListClick(list: AccountReportList): Promise<void>;

  applyInitialFilter(): void;

  onFilterChange(checked: boolean): void;

  onShowListClick(list: AccountReportList): Promise<void>;

  openAcceptDialog(): void;

  closeAcceptDialog(): void;

  closeEditor(): void;

  closeAssignList(): void;

  editReportList(listId: number): Promise<void>;

  assignFile(file: any): Promise<void>;

  changeViewMode(viewMode: ViewMode): void;

  loadList(listId: number): Promise<AccountReportList | null | undefined>;

  updateHookForm(hookForm: any): void;

  saveList(): Promise<void>;

  showReport(report: AccountReport): Promise<void>;

  selectList(list: AccountReportList): Promise<void>;

  closeViewer(): void;

  closeSelectList(): void;

  closeReportDialog(): void;

  updateItemCategory(itemId: number, categoryId: number | null | string | undefined): void;

  updateDetailCategoryId(detailId: number, categoryId: number | null | string | undefined): void;

  updateItemDetails(item: AccountReportListItem, detailsData: any): void;

  deleteDetail(detailId: any): void;

  showReportListByReportId(reportId: number): Promise<void>;

  publish(): Promise<void>;
}

export interface DialogState {
  accept: {
    reportForPublish: AccountReport | null;
    isOpen: boolean;
  };
  editor: {
    listForEdition: AccountReportList | null;
    isOpen: boolean;
    viewMode: boolean;
    isError: boolean;
    isLoading: boolean;
  };
  viewer: {
    selectedReport: AccountReport | null;
    selectedList: AccountReportList | null;
    isOpen: boolean;
  };
  freeMode: {
    isOpen: boolean;
  };
}

export const AccountReportsServiceIdentifier = Symbol.for('AccountReportsService');
